module.exports = __FOREMAN_VENDOR__HUMANIZE_DURATION__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__HUMANIZE_DURATION__"
// module id = humanize-duration
// module chunks = 0 1 2